module.exports = __webpack_public_path__ + "img/import.c1396cf9.svg";